import { Component, OnInit } from '@angular/core';
import { SsAuthService } from 'shared/services/SS-Auth/ss-auth.service';
import { UserService } from 'shared/services/User/user.service';

@Component({
  selector: 'app-team-account',
  templateUrl: './team-account.component.html',
  styleUrls: ['./team-account.component.css']
})
export class TeamAccountComponent implements OnInit {
  loading: boolean;
  accounts: any = [];
  constructor(
    private authService: SsAuthService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.getTeams();
  }

  getTeams() {
    this.loading = true;
    this.authService.getTeamAuths(this.userService.user.token).subscribe(res => {
      this.accounts = res.accounts;
      this.loading = false;
    }, err => {
      console.log(err);
      this.loading = false;
      this.accounts = [];
    });
  }

  addNew() {

  }

  seeTickets(group) {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/team-account/team-account.component.ts